// extracted by mini-css-extract-plugin
export default {"loadingContainer":"Loading_loadingContainer__1baqN","lds":"Loading_lds__lCNxQ"};